import { DateTime } from '@ksyos/date-time';

export function NullableFormattedDate(props: { value?: Date | string | null }) {
    if (props.value) {
        if (typeof props.value === 'string' && props.value.length === 10) {
            return <>{DateTime.parseUtc(props.value, 'YYYY-MM-DD').format('l')}</>;
        }

        return <>{DateTime.from(props.value).format('l')}</>;
    } else {
        return null;
    }
}
